import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Timings() { 
  useEffect(() => {
    document.title = 'Timings -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Timings</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Timings</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                    <div className="table-responsive">
                        <table className="table maintable">
                         <thead>
                              <tr>
                                 <th>School Timings</th>
                                 <th>Office Timings</th>
                              </tr>
                         </thead>
                        <tbody>
                            <tr className="tablebg">
                                <td colspan="2">Monday to Friday</td>
                            </tr>
                            <tr> 
                                <td>Summer : 7:00 am to 1:00 pm <br/> Winter : 8:00 am to 2:00 pm</td>
                                <td>Summer : 7:30 am to 12:30 pm <br/>Winter : 8:30 am to 1:00 pm </td>
                            </tr>
                            <tr className="tablebg">
                            <td colspan="2">On Saturdays</td>
                            </tr>
                            <tr>
                                <td>Summer : 7:00 am to 11:30 am <br/>Winter : 8:00 am to 12:30 pm</td>
                                <td>Summer : 7:30 am to 11:30 am <br/>Winter : 8:30 am to 12:00 pm </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
               </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Timings;
